/* Light Armor — Bold Options guard (2026-08-25)
 *
 * Loaded from snippets/la-buy-top.liquid, which renders inside the buy-buttons block
 * ahead of the product form. A plain (non-deferred) script tag there executes before
 * the inline guard further down main-product.liquid, and this file claims
 * window.__laBoldGuardInit — so that inline copy sees "already initialised" and returns
 * without doing anything. The inline block in main-product.liquid is now dead code and
 * should be deleted whenever that file is next edited.
 *
 * What the guard is for: Bold Options renders the upgrade choices client-side. If its
 * script is blocked (ad blocker, privacy extension) the page would otherwise let someone
 * cart a bare oven with none of its configuration. So Add to Cart ships disabled and is
 * released only once Bold has actually rendered.
 *
 * Two faults in the previous copy, both fixed here:
 *
 *   1. It froze the tab. Once past its timeout it assigned btn.textContent on every pass,
 *      unconditionally. It also watched document.body for childList changes — so that
 *      write woke its own observer, which wrote again, which woke it again: an unbroken
 *      loop that pinned the CPU roughly eight seconds after load. Every DOM write here is
 *      now conditional on the value actually changing, and the observer is coalesced.
 *
 *   2. It ran on every product. Accessories and spare parts have no options configured in
 *      Bold, so Bold correctly renders nothing for them and the gate could never open:
 *      Add to Cart stayed disabled forever and the shopper was told, wrongly, that their
 *      ad blocker was to blame. window.__laGuardExpected (set by the snippet from the
 *      specs.series metafield, which every oven and booth carries and no accessory does)
 *      now says whether this product is one Bold configures.
 */
(function () {
  if (window.__laBoldGuardInit) return;
  window.__laBoldGuardInit = true;

  /* Default to guarding: if the flag is missing for any reason, fail safe. */
  var EXPECTED = window.__laGuardExpected !== false;

  var TIMEOUT_MS = 8000;
  var passed = !EXPECTED;        /* option-free product: nothing to wait for */
  var timedOut = false;

  function boldReady() {
    var els = document.querySelectorAll('.bold_options');
    for (var i = 0; i < els.length; i++) {
      if (els[i].children.length > 0) return true;
    }
    return false;
  }

  /* Bold's script sets window.BOLD as soon as it loads. If it loaded and still rendered
     nothing by the deadline, this product simply has no options set up in the app — not a
     blocked script — so don't hold the cart hostage. Covers a future oven whose
     specs.series metafield was never filled in. */
  function boldLoaded() {
    return !!window.BOLD;
  }

  function setText(btn, text) {
    if (btn.textContent !== text) btn.textContent = text;   /* never write a no-op: see note 1 above */
  }

  function applyState() {
    var btns = document.querySelectorAll('.js-product-form-main button[name="add"]');
    for (var i = 0; i < btns.length; i++) {
      var btn = btns[i];
      if (passed) {
        if (btn.getAttribute('data-bold-guard') !== 'ready') {
          btn.setAttribute('data-bold-guard', 'ready');
          if (!btn.hasAttribute('data-variant-unavailable')) {
            if (btn.disabled) btn.disabled = false;
            var t = btn.getAttribute('data-add-to-cart-text');
            if (t && btn.textContent.indexOf('Loading') !== -1) setText(btn, t);
          }
        }
      } else {
        if (!btn.disabled) btn.disabled = true;
        if (btn.getAttribute('data-bold-guard') !== 'pending') btn.setAttribute('data-bold-guard', 'pending');
        if (timedOut && !btn.hasAttribute('data-variant-unavailable')) {
          setText(btn, 'Options Not Loaded');
        }
      }
    }
    var m = document.querySelector('.js-bold-guard-message');
    var hide = !(timedOut && !passed);
    if (m && m.hidden !== hide) m.hidden = hide;
  }

  function check() {
    if (!passed && boldReady()) passed = true;
    applyState();
  }

  /* Coalesce observer callbacks: Bold fires many mutations per render. */
  var queued = false;
  function queueCheck() {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; check(); }, 50);
  }

  /* Enforcement: block main-form submits while the guard is pending, even if something
     else re-enables the button. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!passed && form && String(form.className || '').indexOf('js-product-form-main') !== -1) {
      e.preventDefault();
      e.stopImmediatePropagation();
      timedOut = true;
      applyState();
    }
  }, true);

  function start() {
    new MutationObserver(queueCheck).observe(document.body, { childList: true, subtree: true });
    check();
  }

  setTimeout(function () {
    if (passed) return;
    if (boldLoaded()) { passed = true; applyState(); return; }
    timedOut = true;
    applyState();
  }, TIMEOUT_MS);

  /* This file loads ahead of the product form, so document.body may not exist yet. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
